import React, { Component } from "react";

import { AuthContext } from "../../components/Auth/AuthDataProvider.jsx";
import apiUtil from "../../api/apiUtil.jsx";
import ldsApi from "../../api/ldsApi.jsx";
import BreadCrumb from "../../components/Navs/Breadcrumb";
import moment from "moment";

import { Box, Grid, IconButton, Tooltip } from "@material-ui/core";
import Icon from "@material-ui/core/Icon";

import { ReactComponent as EditIcon } from "../../assets/img/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../assets/img/icons/delete.svg";

import StickyPageHeader from "../../components/PageHeader/StickyPageHeader.jsx";
import Card from "../../components/Card/Card.jsx";
import Table from "../../components/Table/Table.jsx";
import CustomLabel from "../../components/CustomFields/CustomLabel.jsx";
import CustomInput from "../../components/CustomFields/CustomInput.jsx";
import CustomButton from "../../components/CustomFields/CustomButton.jsx";
import CustomDialog from "../../components/Dialog/CustomDialog.jsx";

export class AnnouncementList extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.refTable = React.createRef();

    this.state = {
      isLoading: false,
      data: [],
      total: 0,
      page: 1,
      limit: 20,

      // Form dialog states
      openFormDialog: false,
      formMode: "create", // "create" or "edit"
      editingItem: null,

      // Delete dialog states
      openDeleteDialog: false,
      deleteItem: null,

      // Form fields
      formData: {
        title: "",
        description: "",
        start_date: moment().format("YYYY-MM-DDTHH:mm"),
        end_date: moment().add(1, 'day').format("YYYY-MM-DDTHH:mm"),
        is_active: true
      },

      // Form validation
      formErrors: {
        title: "",
        description: "",
        start_date: "",
        end_date: ""
      }
    };
  }

  componentDidMount() {
    this.callReadApi();
  }

  /* API METHODS */
  callReadApi = () => {
    const { accessToken } = this.context;

    // Debug and validate accessToken
    if (!accessToken) {
      console.error("Access token is undefined - user may not be authenticated");
      this.setState({ isLoading: false });
      return;
    }

    this.setState({ isLoading: true });

    const params = {
      page: this.state.page,
      limit: this.state.limit
    };

    ldsApi.get("/admin/api/annoucements", params, accessToken)
      .then((result) => {
        if (result.data && result.data.data && result.data.data.status) {
          // API returned successful response
          this.setState({
            data: result.data.data.result || [],
            total: result.data.data.total || result.data.data.result?.length || 0,
            isLoading: false
          });
        } else {
          console.error("Error fetching announcements:", result.errorMessage);
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        console.error("API error:", error);
        this.setState({ isLoading: false });
      });
  };

  callCreateApi = (formData, callback = null) => {
    const { accessToken } = this.context;

    // Debug and validate accessToken
    if (!accessToken) {
      console.error("Access token is undefined - user may not be authenticated");
      this.setState({ isLoading: false });
      if (callback) callback(false, "Authentication required");
      return;
    }

    this.setState({ isLoading: true });

    ldsApi.create("annoucements", formData, accessToken)
      .then((result) => {
        apiUtil.parseResult(
          result,
          (data) => {
            this.setState({ isLoading: false });
            if (callback) callback(true);
            this.callReadApi(); // Refresh list
          },
          (error, type) => {
            console.error("Error creating announcement:", error);
            this.setState({ isLoading: false });
            if (callback) callback(false, error);
          }
        );
      })
      .catch((error) => {
        console.error("Create API error:", error);
        this.setState({ isLoading: false });
        if (callback) callback(false, error);
      });
  };

  callUpdateApi = (id, formData, callback = null) => {
    const { accessToken } = this.context;

    // Debug and validate accessToken
    if (!accessToken) {
      console.error("Access token is undefined - user may not be authenticated");
      this.setState({ isLoading: false });
      if (callback) callback(false, "Authentication required");
      return;
    }

    this.setState({ isLoading: true });

    ldsApi.update(`annoucements/${id}`, formData, accessToken)
      .then((result) => {
        apiUtil.parseResult(
          result,
          (data) => {
            this.setState({ isLoading: false });
            if (callback) callback(true);
            this.callReadApi(); // Refresh list
          },
          (error, type) => {
            console.error("Error updating announcement:", error);
            this.setState({ isLoading: false });
            if (callback) callback(false, error);
          }
        );
      })
      .catch((error) => {
        console.error("Update API error:", error);
        this.setState({ isLoading: false });
        if (callback) callback(false, error);
      });
  };

  callDeleteApi = (id, callback = null) => {
    const { accessToken } = this.context;

    // Debug and validate accessToken
    if (!accessToken) {
      console.error("Access token is undefined - user may not be authenticated");
      this.setState({ isLoading: false });
      if (callback) callback(false, "Authentication required");
      return;
    }

    this.setState({ isLoading: true });

    ldsApi.delete(`annoucements/${id}`, null, accessToken)
      .then((result) => {
        apiUtil.parseResult(
          result,
          (data) => {
            this.setState({ isLoading: false });
            if (callback) callback(true);
            this.callReadApi(); // Refresh list
          },
          (error, type) => {
            console.error("Error deleting announcement:", error);
            this.setState({ isLoading: false });
            if (callback) callback(false, error);
          }
        );
      })
      .catch((error) => {
        console.error("Delete API error:", error);
        this.setState({ isLoading: false });
        if (callback) callback(false, error);
      });
  };

  /* FORM HANDLERS */
  handleFormChange = (field, value) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [field]: value
      },
      formErrors: {
        ...this.state.formErrors,
        [field]: ""
      }
    });
  };

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};
    let isValid = true;

    if (!formData.title.trim()) {
      errors.title = "Title is required";
      isValid = false;
    }

    if (!formData.description.trim()) {
      errors.description = "Description is required";
      isValid = false;
    }

    if (!formData.start_date) {
      errors.start_date = "Start date is required";
      isValid = false;
    }

    if (!formData.end_date) {
      errors.end_date = "End date is required";
      isValid = false;
    }

    if (formData.start_date && formData.end_date && 
        moment(formData.start_date).isAfter(moment(formData.end_date))) {
      errors.end_date = "End date must be after start date";
      isValid = false;
    }

    this.setState({ formErrors: errors });
    return isValid;
  };

  handleFormSubmit = () => {
    if (!this.validateForm()) {
      return;
    }

    const { formData, formMode, editingItem } = this.state;
    
    const submitData = {
      title: formData.title.trim(),
      description: formData.description.trim(),
      start_date: moment(formData.start_date).utc().toISOString(),
      end_date: moment(formData.end_date).utc().toISOString()
    };

    if (formMode === "create") {
      this.callCreateApi(submitData, (success, error) => {
        if (success) {
          this.closeFormDialog();
        }
      });
    } else {
      this.callUpdateApi(editingItem.id, submitData, (success, error) => {
        if (success) {
          this.closeFormDialog();
        }
      });
    }
  };

  /* DIALOG HANDLERS */
  openCreateDialog = () => {
    this.setState({
      openFormDialog: true,
      formMode: "create",
      editingItem: null,
      formData: {
        title: "",
        description: "",
        start_date: moment().format("YYYY-MM-DDTHH:mm"),
        end_date: moment().add(1, 'day').format("YYYY-MM-DDTHH:mm"),
        is_active: true
      },
      formErrors: {
        title: "",
        description: "",
        start_date: "",
        end_date: ""
      }
    });
  };

  openEditDialog = (item) => {
    this.setState({
      openFormDialog: true,
      formMode: "edit",
      editingItem: item,
      formData: {
        title: item.title || "",
        description: item.description || "",
        start_date: item.start_date ? moment.utc(item.start_date).local().format("YYYY-MM-DDTHH:mm") : "",
        end_date: item.end_date ? moment.utc(item.end_date).local().format("YYYY-MM-DDTHH:mm") : "",
        is_active: item.is_active !== false
      },
      formErrors: {
        title: "",
        description: "",
        start_date: "",
        end_date: ""
      }
    });
  };

  closeFormDialog = () => {
    this.setState({
      openFormDialog: false,
      formMode: "create",
      editingItem: null
    });
  };

  openDeleteDialog = (item) => {
    this.setState({
      openDeleteDialog: true,
      deleteItem: item
    });
  };

  closeDeleteDialog = () => {
    this.setState({
      openDeleteDialog: false,
      deleteItem: null
    });
  };

  handleDelete = () => {
    if (this.state.deleteItem) {
      this.callDeleteApi(this.state.deleteItem.id, (success) => {
        if (success) {
          this.closeDeleteDialog();
        }
      });
    }
  };

  /* RENDER COMPONENTS */
  customStickyPageHeader = () => {
    return (
      <Box clone pl={4} pr={4} height={"100%"} alignItems={"center"}>
        <Grid container>
          <BreadCrumb xs={true} />
          <Box clone pr={1}>
            <Grid item xs={"auto"}>
              <CustomButton
                color={"secondary"}
                onClick={this.openCreateDialog}
              >
                + New Announcement
              </CustomButton>
            </Grid>
          </Box>
        </Grid>
      </Box>
    );
  };

  customTable = () => {
    return (
      <Table
        ref={this.refTable}
        className={"announcement-table-list"}
        isLoading={this.state.isLoading}
        limit={this.state.limit}
        page={this.state.page}
        total={this.state.total}
        data={this.state.data}
        onPageChange={(page) => {
          this.setState({ page }, () => {
            this.callReadApi();
          });
        }}
        columns={[
          {
            title: "Title",
            field: "title",
            render: (row, type) => {
              if (type === "row") {
                return (
                  <Box>
                    <CustomLabel
                      label={row.title}
                      weight="bold"
                      size="sm"
                    />
                    <Box mt={0.5}>
                      <CustomLabel
                        label={row.description}
                        size="xs"
                        style={{ color: "#666" }}
                      />
                    </Box>
                  </Box>
                );
              }
              return row.title;
            },
          },
          {
            title: "Start Date",
            field: "start_date",
            render: (row, type) => {
              return row.start_date 
                ? moment.utc(row.start_date).local().format(
                                apiUtil.getDefaultDateTimeFormat()
                              )
                : "";
            },
          },
          {
            title: "End Date",
            field: "end_date",
            render: (row, type) => {
              return row.end_date 
                ? moment.utc(row.end_date).local().format(
                                apiUtil.getDefaultDateTimeFormat()
                              )
                : "";
            },
          },
          {
            title: "Status",
            field: "is_active",
            render: (row, type) => {
              const currentDate = moment();
              const startDate = moment.utc(row.start_date).local();
              const endDate = moment.utc(row.end_date).local();
              
              let status = "Inactive";
              let color = "#999";
              
              if (row.is_active) {
                if (currentDate.isBefore(startDate)) {
                  status = "Scheduled";
                  color = "#ff9800";
                } else if (currentDate.isAfter(endDate)) {
                  status = "Expired";
                  color = "#f44336";
                } else {
                  status = "Active";
                  color = "#4caf50";
                }
              }

              return (
                <Box 
                  px={1} 
                  py={0.5} 
                  borderRadius={1}
                  style={{ 
                    backgroundColor: color + '20', 
                    color: color,
                    display: 'inline-block',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}
                >
                  {status}
                </Box>
              );
            },
          },
          {
            title: "Actions",
            field: "actions",
            sorting: false,
            render: (row, type) => {
              if (type === "row") {
                return (
                  <Box display="flex" gap={1}>
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        onClick={() => this.openEditDialog(row)}
                      >
                        <EditIcon style={{ width: 16, height: 16 }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        onClick={() => this.openDeleteDialog(row)}
                      >
                        <DeleteIcon style={{ width: 16, height: 16 }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                );
              }
              return "";
            },
          },
        ]}
      />
    );
  };

  customFormDialog = () => {
    const { openFormDialog, formMode, formData, formErrors, isLoading } = this.state;

    return (
      <CustomDialog
        open={openFormDialog}
        title={formMode === "create" ? "Create Announcement" : "Edit Announcement"}
        isLoading={isLoading}
        onClose={this.closeFormDialog}
        onOk={this.handleFormSubmit}
        btnOkText={formMode === "create" ? "Save" : "Update"}
        maxWidth="md"
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CustomInput
              label="Title"
              value={formData.title}
              onChange={(e) => this.handleFormChange("title", e.target.value)}
              errorText={formErrors.title}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              label="Description"
              value={formData.description}
              onChange={(e) => this.handleFormChange("description", e.target.value)}
              errorText={formErrors.description}
              multiline
              rows={3}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomInput
              label="Start Date & Time"
              type="datetime-local"
              value={formData.start_date}
              onChange={(e) => this.handleFormChange("start_date", e.target.value)}
              errorText={formErrors.start_date}
              required
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomInput
              label="End Date & Time"
              type="datetime-local"
              value={formData.end_date}
              onChange={(e) => this.handleFormChange("end_date", e.target.value)}
              errorText={formErrors.end_date}
              required
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </CustomDialog>
    );
  };

  customDeleteDialog = () => {
    const { openDeleteDialog, deleteItem, isLoading } = this.state;

    return (
      <CustomDialog
        open={openDeleteDialog}
        title="Delete Announcement"
        isLoading={isLoading}
        onClose={this.closeDeleteDialog}
        onOk={this.handleDelete}
        btnOkText="Delete"
        btnOkColor="secondary"
      >
        <Box p={2}>
          <CustomLabel
            label={`Are you sure you want to delete "${deleteItem?.title}"?`}
          />
          <Box mt={1}>
            <Box style={{ color: "#666", fontSize: "12px" }}>
              This action cannot be undone.
            </Box>
          </Box>
        </Box>
      </CustomDialog>
    );
  };

  render() {
    return (
      <Box className="announcement-list-page">
        <StickyPageHeader isSmall={false}>
          {this.customStickyPageHeader()}
        </StickyPageHeader>

        <Card>
          <Box mb={2}>
            <CustomLabel
              label="Announcements"
              weight="bold"
              size="lg"
            />
            <CustomLabel
              label="Manage system announcements and notifications"
              size="sm"
              style={{ color: "#666" }}
            />
          </Box>
          {this.customTable()}
        </Card>

        {this.customFormDialog()}
        {this.customDeleteDialog()}
      </Box>
    );
  }
}

export default AnnouncementList;